<template>
  <div>
    <legend>Отчет №2</legend>
    <div class="form-group row mb-3 mx-auto" style="max-width: 400px">
      <div class="col">
        <date-picker class="w-100" v-model="from" valueType="format"
                     placeholder="С"
                     :input-attr="{required: true}"
                     input-class="form-control"
                     :first-day-of-week="1" lang="ru">
        </date-picker>
      </div>
      <div class="col">
        <date-picker class="w-100" v-model="to" valueType="format"
                     placeholder="По"
                     :input-attr="{required: true}"
                     input-class="form-control"
                     :first-day-of-week="1" lang="ru">
        </date-picker>
      </div>
    </div>
    <div class="overflow-auto">
      <table class="table table-bordered table-sm text-center small" v-if="isLoaded">
        <thead>
        <tr>
          <th></th>
          <th colspan="6" v-for="CustomerCategory in CustomerCategories" class="text-uppercase">
            {{CustomerCategory.Name}}
          </th>
          <th colspan="4" class="text-uppercase">Итого</th>
        </tr>
        <tr>
          <th width="30"></th>
          <template
            v-for="CustomerCategory in CustomerCategories"
          >
            <th width="30">Оправлено</th>
            <th width="30">Доставлено</th>
            <th width="30">Оплачено</th>
            <th width="30">Получено</th>
            <th width="30">Оплачено долги</th>
            <th width="30">Долг</th>
          </template>
          <th width="30">Всего отправлено</th>
          <th width="30">Всего получено</th>
          <th width="30">Всего оплачено долгов</th>
          <th width="30">Расходы</th>
        </tr>
        </thead>
        <tbody>

        <tr>
          <td>Заказы</td>
          <template
            v-for="CustomerCategory in CustomerCategories"
          >
            <td>{{sumCountOrder(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDispatch)}}</td>
            <td>
              {{sumCountOrder(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDelivered)}}
            </td>
            <td>{{sumCountOrder(report.CategoryStats[CustomerCategory.Id].Stats.OrdersPaid)}}</td>
            <td>{{sumCountOrder(report.CategoryStats[CustomerCategory.Id].Stats.OrdersPassed)}}</td>
            <td>{{sumCountOrder(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDebtPaid)}}</td>
            <td>{{sumCountOrder(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDebtCurrent)}}
            </td>
          </template>
          <td>{{AllDispatched.OrdersDispatch.CountOrder}}</td>
          <td>{{AllDispatched.OrdersPassed.CountOrder}}</td>
          <td>{{AllDispatched.OrdersDebtPaid.CountOrder}}</td>
          <td></td>
        </tr>
        <tr>
          <td>Штуки</td>
          <template
            v-for="CustomerCategory in CustomerCategories"
          >
            <td>{{sumCountAmount(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDispatch)}}
            </td>
            <td>{{sumCountAmount(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDelivered)}}
            </td>
            <td>{{sumCountAmount(report.CategoryStats[CustomerCategory.Id].Stats.OrdersPaid)}}</td>
            <td>{{sumCountAmount(report.CategoryStats[CustomerCategory.Id].Stats.OrdersPassed)}}</td>
            <td>{{sumCountAmount(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDebtPaid)}}
            </td>
            <td>
              {{sumCountAmount(report.CategoryStats[CustomerCategory.Id].Stats.OrdersDebtCurrent)}}
            </td>
          </template>
          <td>{{AllDispatched.OrdersDispatch.CountAmount}}</td>
          <td>{{AllDispatched.OrdersPassed.CountAmount}}</td>
          <td>{{AllDispatched.OrdersDebtPaid.CountAmount}}</td>
          <td></td>
        </tr>
        <tr v-for="PaymentType in report.PaymentTypes">
          <td>{{PaymentType.Name}}</td>
          <template
            v-for="CustomerCategory in CustomerCategories"
          >
            <td>
              {{report.CategoryStats[CustomerCategory.Id].Stats.OrdersDispatch[PaymentType.Id].CountSummary
              || 0}}
            </td>
            <td>
              {{report.CategoryStats[CustomerCategory.Id].Stats.OrdersDelivered[PaymentType.Id].CountSummary
              || 0}}
            </td>
            <td>
              {{report.CategoryStats[CustomerCategory.Id].Stats.OrdersPaid[PaymentType.Id].CountSummary
              || 0}}
            </td>
            <td>
              {{report.CategoryStats[CustomerCategory.Id].Stats.OrdersPassed[PaymentType.Id].CountSummary
              || 0}}
            </td>
            <td>
              {{report.CategoryStats[CustomerCategory.Id].Stats.OrdersDebtPaid[PaymentType.Id].CountSummary
              || 0}}
            </td>
            <td>
              {{report.CategoryStats[CustomerCategory.Id].Stats.OrdersDebtCurrent[PaymentType.Id].CountSummary
              || 0}}
            </td>
          </template>
          <td>{{AllDispatched.OrdersDispatch.Stats[PaymentType.Id]}}</td>
          <td>{{AllDispatched.OrdersPassed.Stats[PaymentType.Id]}}</td>
          <td>{{AllDispatched.OrdersDebtPaid.Stats[PaymentType.Id]}}</td>
          <td>{{report.TodayExpense[PaymentType.Id]}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';

const defaultDateFrom = moment().subtract(5, 'days').format('YYYY-MM-DD');
// const defaultDateFrom = moment().format('YYYY-MM-DD');
const defaultDateTo = moment().format('YYYY-MM-DD');
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      from: defaultDateFrom,
      to: defaultDateTo,
      report: {},
      isLoaded: false,
    };
  },
  mounted() {
    this.fetchDayReport();
  },
  watch: {
    from(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
    to(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
  },
  computed: {
    CustomerCategories() {
      if (!this.report.CategoryStats) {
        return [];
      }
      return _.map(this.report.CategoryStats, CustomerCategory => CustomerCategory.CustomerCategory);
    },
    AllDispatched() {
      if (_.isEmpty(this.report)) {
        return {};
      }
      const result = {
        OrdersDispatch: {
          CountOrder: 0,
          CountAmount: 0,
          Stats: {},
        },
        OrdersPassed: {
          CountOrder: 0,
          CountAmount: 0,
          Stats: {},
        },
        OrdersDebtPaid: {
          CountOrder: 0,
          CountAmount: 0,
          Stats: {},
        },
      };
      _.each(this.report.PaymentTypes, (pt) => {
        _.each(this.report.CategoryStats, (cs) => {
          result.OrdersDispatch.CountOrder += (cs.Stats.OrdersDispatch[pt.Id].CountOrder || 0);
          result.OrdersDispatch.CountAmount += (parseInt(cs.Stats.OrdersDispatch[pt.Id].CountAmount) || 0);
          result.OrdersDispatch.Stats[pt.Id] = (result.OrdersDispatch.Stats[pt.Id] || 0) + (parseInt(cs.Stats.OrdersDispatch[pt.Id].CountSummary) || 0);

          result.OrdersPassed.CountOrder += (cs.Stats.OrdersPassed[pt.Id].CountOrder || 0);
          result.OrdersPassed.CountAmount += (parseInt(cs.Stats.OrdersPassed[pt.Id].CountAmount) || 0);
          result.OrdersPassed.Stats[pt.Id] = (result.OrdersPassed.Stats[pt.Id] || 0) + (parseInt(cs.Stats.OrdersPassed[pt.Id].CountSummary) || 0);

          result.OrdersDebtPaid.CountOrder += (cs.Stats.OrdersDebtPaid[pt.Id].CountOrder || 0);
          result.OrdersDebtPaid.CountAmount += (parseInt(cs.Stats.OrdersDebtPaid[pt.Id].CountAmount) || 0);
          result.OrdersDebtPaid.Stats[pt.Id] = (result.OrdersDebtPaid.Stats[pt.Id] || 0) + (parseInt(cs.Stats.OrdersDebtPaid[pt.Id].CountSummary) || 0);
        });
      });
      return result;
    },
    allDebt() {
      const CountOrder = _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, ofd => +ofd.CountOrder));
      const CountAmount = _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, ofd => +ofd.CountAmount));
      const ptDebts = _.map(this.report.pTypes, pt => _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, (ofd) => {
        if (ofd.PaymentTypeId === pt.Id) {
          return +ofd.CountSummary;
        }
        return 0;
      })));
      return {
        CountOrder,
        CountAmount,
        ptDebts,
      };
    },
    allPaid() {
      const CountOrder = _.sumBy(
        this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, ofd => +ofd.CountOrder) + _.sumBy(cs.stats.ordersDebtYesterday, ofd => +ofd.CountOrder),
      );
      const CountAmount = _.sumBy(
        this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, ofd => +ofd.CountAmount) + _.sumBy(cs.stats.ordersDebtYesterday, ofd => +ofd.CountAmount),
      );
      const ptDebts = _.map(
        this.report.pTypes, pt => _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, (ofd) => {
          if (ofd.PaymentTypeId === pt.Id) {
            return +ofd.CountSummary;
          }
          return 0;
        })
          + _.sumBy(cs.stats.ordersDebtYesterday, (ofd) => {
            if (ofd.PaymentTypeId === pt.Id) {
              return +ofd.CountSummary;
            }
            return 0;
          })),
      );
      return {
        CountOrder,
        CountAmount,
        ptDebts,
      };
    },
  },
  methods: {
    sumCountOrder(stats) {
      return _.sumBy(_.values(stats), o => (o.CountOrder ? +o.CountOrder : 0));
    },
    sumCountAmount(stats) {
      return _.sumBy(_.values(stats), o => (o.CountAmount ? +o.CountAmount : 0));
    },
    getSummaryByPaymentTypeId(paymentTypeId, stats) {
      const ptStats = _.findLast(stats, n => n.PaymentTypeId === paymentTypeId);
      return ptStats ? ptStats.CountSummary : 0;
    },
    async fetchDayReport() {
      this.isLoaded = false;
      console.log(this.date);
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/stats/day-report/${this.from}/${this.to}`);
      this.report = data;
      console.log(this.report);
      this.isLoaded = true;
    },
  },
};
</script>
